import { post } from 'bjxy-common/network/http'
import { api } from '../utils'
import getWXUnionid from 'bjxy-common/xyHelper/getWXUnionid'

export function getOpenId(){
  if(this.extend.isGetWXUnionid !== '1'){
    return false
  } 
  getWXUnionid({}, ({ errcode, data }) => {
    if (errcode === 0 && data.weChatUser) {
      this.config.openId = data.weChatUser.openId
    }
  })
}

export function bindWechat(openId, cb) {
  if(!openId) {
    return cb && cb()
  }
  post(api.BIND_WECHAT, { openId }).finally(()=>{
    cb && cb()
  })
}